/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { Helmet } from "react-helmet";

import { useEventThemeLogos } from "hooks/useEventThemeLogos";
import { useEnvs } from "state/EnvironmentsContext/EnvContext";

const FavIcon = () => {
  const { title } = useEnvs();
  const { favicon } = useEventThemeLogos();

  return (
    <Helmet test-id="EbWMB8yn">
      {favicon && (
        <link
          rel="icon"
          href={`${favicon}?v=1`}
          type="image/x-icon"
          test-id="4RDNAG-W"
        />
      )}

      <title test-id="hz37fHFP">{title}</title>
    </Helmet>
  );
};

export default FavIcon;
